import {makeAutoObservable} from "mobx";
import {api, catchApi} from "../../api";

const systemApi = api.sls.api

export interface CabinetOption {
    value: string
    label: string
}

class StsCustomerCabinetStore {
    get cabinets(): string[] {
        return this._cabinets;
    }

    private set cabinets(value: string[]) {
        this._cabinets = value;
    }

    get cabinetsAsOption(): CabinetOption[] {
        return (this.cabinets || []).map(cabinet => ({
            value: cabinet,
            label: cabinet
        }))
    }

    private _cabinets: string[] = []

    constructor() {
        makeAutoObservable(this)
    }

    reset() {
        this.cabinets = []
    }

    async load(id: string) {
        const response = await catchApi(async () => await systemApi.getCustomerCabinets(id))
        this.cabinets = response?.data || []
    }
}

const stsCustomerCabinetStore = new StsCustomerCabinetStore()

export {
    stsCustomerCabinetStore
}
